export default __webpack_public_path__ + "static/media/favicon.02471421.svg";